import React from "react";

/**
 * The shell both legal pages share: a quiet header, one column, and text set
 * to a readable measure. Nothing here should compete with the content — these
 * are pages somebody reads once, carefully, usually before paying.
 */

export default function LegalPage({ title, updated, children }) {
  return (
    <>
      <section className="bg-primary-900 pt-36 pb-20 px-4 text-white">
        <div className="max-w-3xl mx-auto">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-400 mb-5">
            D, Trio Trek
          </p>
          <h1 className="font-display text-4xl md:text-5xl font-normal tracking-tight">
            {title}
          </h1>
          {updated && (
            <p className="text-white/50 text-sm mt-4">Last updated {updated}</p>
          )}
        </div>
      </section>

      <section className="section-y px-4">
        <div className="max-w-3xl mx-auto">{children}</div>
      </section>
    </>
  );
}

export const H2 = ({ children }) => (
  <h2 className="font-display text-2xl md:text-3xl font-normal tracking-tight text-primary-900 mt-12 first:mt-0 mb-4">
    {children}
  </h2>
);

export const H3 = ({ children }) => (
  <h3 className="font-semibold text-primary-900 mt-8 mb-2">{children}</h3>
);

export const P = ({ children }) => (
  <p className="text-primary-600 leading-relaxed mb-4">{children}</p>
);

export const UL = ({ items }) => (
  <ul className="space-y-3 mb-4">
    {items.map((item, i) => (
      <li key={i} className="flex gap-3 text-primary-600 leading-relaxed">
        <span className="text-accent-500 flex-shrink-0 mt-1.5 w-1 h-1 rounded-full bg-current" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);
